export const EstadoAprobacionEvaluacion = {
    PENDIENTE: "PENDIENTE",
    APROBADO: "APROBADO",
    PENDIENTE_APROBACION_GH: "PENDIENTE_APROBACION_GH",
    PLAN_ACCION_REALIZADO: "PLAN_ACCION_REALIZADO",
    PLAN_ACCION_PENDIENTE:"PLAN_ACCION_PENDIENTE"
    
}